import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { Icon } from "../../components/Icon";
import Hint from "../../components/Hint/Hint";
import { useSelector } from "react-redux";

const RoomConditionsPage = () => {
  const [open, setOpen] = useState('');
  const [isDisabled, setIsDisabled] = useState(true);
  const offerRef = useRef(null);
  const hint =useSelector(state=>state.hints);
  const navigate = useNavigate();
  const location = useLocation();
  const { fallback } = location.state || {};
  const { team } = location.state || {};

  const openClick = (e) => {
    const id = e.currentTarget.id;
		
		open === id ? setOpen('') : setOpen(id);
  };

  const onConsentClick = () => {
    navigate(fallback || '/', { state: { userConsent: true, openSidebar: true, team: team } });
  }

  const onDecline = () => {
    navigate(fallback || '/', { state: { userConsent: false, openSidebar: false, team: team } });
  }

  useEffect(() => {
    const offer = offerRef.current;

    if (!offer) return;

    const handleDisabled = (e) => {
      if (offer.scrollHeight / (offer.clientHeight + offer.scrollTop) < 1.05) {
        setIsDisabled(false);
      }
    };

    offer.addEventListener('scroll', handleDisabled)

    return(() => {
      offer.removeEventListener('scroll', handleDisabled)
    })
  }, [])

  return (
    <div className="flexCol alignCenter conditionsPage">
      <div className="conditionsTop">
        <div className="flexCol alignCenter">
          <h2 >Умови участі в кімнаті
            <div className="infoHelp">
              <Hint align='center' item={hint[67]}/>
            </div>
          </h2>
          <p className="prInputLabel" style={{ marginTop: '8px', textAlign: 'center' }}>
            Це обов’язкова сторінка, із якою повинен ознайомитись кожен учасник кімнати. Будь ласка, зверніть увагу на блок питання/відповідь.
          </p>
        </div>

        <div className="attentionPart dFlex" style={{ marginTop: '30px' }}>
            <div className="warningModalIcon"> <Icon type='warning'></Icon></div>
            <div>
                <h3>Важливо</h3>
                <div>Інформація в цьому розділі <strong>може вберегти вас від втрати грошей</strong></div>
            </div>
        </div>

        <div className="flexCol alignCenter clientInformer" style={{ marginTop: '30px' }}>
          <p className="prInputLabel" style={{ marginTop: '8px' }}>
            Якщо ви вважаєте, що ваш суперник грав нечесно, або підробив результати, найкращим доказом вашої правоти буде відеозапис гри.
            <br />
            <br />
            Ви можете зробити відеозапис за допомогою нашого клієнта, встановивши його на свій комп’ютер (доступний лише для Windows 10 і вище), або використати будь-який інший спосіб запису відео з екрану. Більш детально можна прочитати у блоці питання /відповідь
          </p>
          <a target={'_blank'} href="https://my.rivalsroom.com/assets/program/RivalsRoomClient.Setup-2.exe">
            <button className="prButton prButtonMain">Завантажити клієнт</button>
          </a>
          <p className="prInputLabel">
            <strong>Зверніть увагу!</strong> Ми радимо записувати КОЖНУ свою гру. Ви завжди можете її видалити після того, як кімната буде успішно закрита.
          </p>
        </div>
      </div>

    <div className="flexCol alignCenter" style={{ marginTop: '70px', width: '100%' }}>
      <h3 className="chatSectionHeader">
        Порядок дій складається із чотирьох простих кроків
      </h3>
      <div className="prFlexRow conditionsImagesWrapper" style={{ marginTop: '45px', width: '100%' }}>
        <div className="faq step">
          <h4 className="conditionsStepLabel">
            Крок 1
          </h4>
          <span className="prInputLabel">
            Запишіть відео за допомогою клієнта, або будь-яким іншим способом
          </span>
        </div>
        <Icon type="rightArrowLg"/>
        <div className="faq step">
          <h4 className="conditionsStepLabel">
            Крок 2
          </h4>
          <span className="prInputLabel">
            Завантажте відео на Google Диск чи Dropbox
          </span>
        </div>
        <Icon type="rightArrowLg"/>
        <div className="faq step">
          <h4 className="conditionsStepLabel">
            Крок 3
          </h4>
          <span className="prInputLabel">
            Відкрийте зальний доступ до відео
          </span>
        </div>
        <Icon type="rightArrowLg"/>
        <div className="faq step">
          <h4 className="conditionsStepLabel">
            Крок 4
          </h4>
          <span className="prInputLabel">
            Надішліть посилання через форму виклику арбітра на сторінці кімнати
          </span>
        </div>
      </div>
    </div>

      <div className="faq" style={{ marginTop: '70px' }}>
        <h2 style={{ textAlign: 'center' }}>
          Питання/Відповідь
        </h2>
        <div className="prFlexRow directoryGroup">
            <div id='first-question' onClick={openClick} className="prFlexRow directoryGroupName">
              <div className={open=='first-question'?"arrowForwardOpen":"arrowForwardOpen arrowForwardOpenTransform"}>
                <Icon type='arrowForward'></Icon>
              </div>
              <div>Як записати відео?</div>
            </div>
            {open === 'first-question' && (
              <p className="prInputLabel answer">
                Ви можете використати створений нами <a href="https://my.rivalsroom.com/assets/program/RivalsRoomClient.Setup-2.exe">клієнт</a>, або будь-яку іншу програму для запису екрану.
              </p>
            )}
        </div>
        <div className="prFlexRow directoryGroup">
            <div id='second-question' onClick={openClick} className="prFlexRow directoryGroupName">
              <div className={open=='second-question'?"arrowForwardOpen":"arrowForwardOpen arrowForwardOpenTransform"}>
                <Icon type='arrowForward'></Icon>
              </div>
              <div>Як працює клієнт?</div>
            </div>
            {open === 'second-question' && (
              <p className="prInputLabel answer">
                Для того, щоб записати відео із процесом гри, треба завантажити клієнт за <a href="https://my.rivalsroom.com/assets/program/RivalsRoomClient.Setup-2.exe">посиланням</a>, і встановити його на комп'ютер (лише для Windows 10 і вище).
                <br />
                <br />
                Після того, як ви надасте клієнту всі потрібні права, які він просить, можна починати запис. Зверніть увагу, на диску повинно бути достатньо місця для того, щоб клієнт міг зберегти записаний ігровий процес.
                <br />
                <br />
                Якщо у вас два монітори, оберіть той монітор, на якому відображається ігровий процес. 
                <br />
                <br />
                Після того, як створена кімната та перейде в режим очікування результату, скопіюйте ID кімнати, і вставте його у відповідне поле клієнта.
                <br />
                <br />
                Далі - натискайте на кнопку запису.
                <br />
                <br />
                По закінченню гри зупиніть запис, і клієнт почне в автоматичному режимі вивантажувати відео на наш сервер.
              </p>
            )}
        </div>
        <div className="prFlexRow directoryGroup">
            <div id='third-question' onClick={openClick} className="prFlexRow directoryGroupName">
              <div className={open=='third-question'?"arrowForwardOpen":"arrowForwardOpen arrowForwardOpenTransform"}>
                <Icon type='arrowForward'></Icon>
              </div>
              <div>Вимоги до відео?</div>
            </div>
            {open === 'third-question' && (
              <p className="prInputLabel answer">
                <ul>
                  <li>
                    Відео повинно відображати всю область монітору, на якому відбувається ігровий процес.
                  </li>
                  <li>
                    Відео повинно бути достатньої якості для того, щоб можна було ідентифікувати нікнейми гравців та ключові моменти, які дозволять визначити порушення.
                  </li>
                </ul>
              </p>
            )}
        </div>
        <div className="prFlexRow directoryGroup">
            <div id='fourth-question' onClick={openClick} className="prFlexRow directoryGroupName">
              <div className={open=='fourth-question'?"arrowForwardOpen":"arrowForwardOpen arrowForwardOpenTransform"}>
                <Icon type='arrowForward'></Icon>
              </div>
              <div>Що ми вважаємо нечесною грою?</div>
            </div>
            {open === 'fourth-question' && (
              <p className="prInputLabel answer">
                <ul>
                  <li>
                    Використання чіт-кодів та інших технічних методів отримання ігрової переваги, що не передбачені налаштуваннями гри.
                  </li>
                  <li>
                    Передачу облікового запису іншому гравцю
                  </li>
                  <li>
                    Невідповідність нікнейму в грі та нікнейму в ігровій кімнаті
                  </li>
                </ul>
              </p>
            )}
        </div>
        <div className="prFlexRow directoryGroup">
            <div id='fifth-question' onClick={openClick} className="prFlexRow directoryGroupName">
              <div className={open=='fifth-question'?"arrowForwardOpen":"arrowForwardOpen arrowForwardOpenTransform"}>
                <Icon type='arrowForward'></Icon>
              </div>
              <div>Як передати відео?</div>
            </div>
            {open === 'fifth-question' && (
              <p className="prInputLabel answer">
                Завантажте відеофайл на Google Диск чи Dropbox, та відкрийте до нього публічний доступ. Наші арбітри будуть переглядати його, і скоріш за все не один раз, тому потурбуйтесь, щоб відео було доступним весь час, поки йде процес визначення переможця.
              </p>
            )}
        </div>
      </div>

      <div className="flexCol alignCenter offerSection" style={{ marginTop: '70px' }}>
				<h2>
					Договір оферта
        </h2>
				<p
          className="prInputLabel"
          style={{ marginTop: '40px' }}
          ref={offerRef}
        >
          <p>
          1. ЗАГАЛЬНІ ПОЛОЖЕННЯ
          </p>
          <p>
          1.1. Ця Угода (далі – "Угода") встановлює правила участі користувачів (далі – "Учасник") у кімнатах (далі – "Кімната") на платформі RivalsRoom (далі – "Платформа"), яка керується ТОВ "РайвалсРум Україна" (далі – "Оператор").
          </p>
          <p>
          1.2. Приєднання до Кімнати означає повне та безумовне прийняття Учасником умов цієї Угоди, Правил Користування Платформою, Політики конфіденційності, Політики чесної гри, Дисциплінарних правил та інших чинних документів, що діють на Платформі.
          </p>
          <p>
          1.3. Ця Угода є договором приєднання в розумінні ст. 634 Цивільного кодексу України.
          </p>
          <p>
          2. ПРИЄДНАННЯ ДО КІМНАТИ ТА ФОРМУВАННЯ ПРИЗОВОГО ФОНДУ
          </p>

          <p>
          2.1. Створення Кімнати відбувається ініціатором (далі – "Ініціатор"), який встановлює її умови:
          </p>

          <p>
          •	визначення дисципліни (гри);
          </p>

          <p>
          •	розмір внеску для участі в Кімнаті в ігрових токенах;
          </p>

          <p>
          •	термін початку гри (дата й час).
          </p>
          <p>
          При створенні Кімнати генерується унікальний ідентифікатор Кімнати та гіперпосилання для відправки іншим учасникам чи публікації в мережі Інтернет для відкритого (доступного всім та будь-яким особам, які мають акаунт на Платформі) чи закритого (доступного лише особам із закритого, заздалегідь обмеженого переліку користувачів Платформи) приєднання.
          </p>
          <p>
          2.2. Ініціатор кімнати визначає розмір внеску для участі в Кімнаті в ігрових токенах у діапазоні від мінімального внеску (1 токен) до максимального (5000 токенів). Токени списуються з особистого рахунку ініціатора в токенах на Платформі та з особистих рахунків інших користувачів-учасників кімнати лише після активації кімнати (коли склад кімнати повністю сформований, і всі учасники кімнати натиснули «Уперед»).
          </p>
          <p>
          Для участі в Кімнаті кожен Учасник зобов'язаний внести встановлений Ініціатором внесок за участь у кімнаті, з яких формується сукупний призовий фонд Кімнати.
          </p>
          <p>
          2.3. Учасник підтверджує, що він ознайомлений з умовами Кімнати до приєднання та не може змінювати або оскаржувати їх після вступу. Внутрі кімнати, натискаючи кнопку «Уперед», учасник погоджує готовність взяти участь у грі на вказаних умовах, а також виражає свою згоду з цією угодою про участь у кімнаті.
          </p>
          <p>
          2.4. Результат кімнати визначається виключно результатом гри учасників кімнати поза межами Платформи
          </p>
          <p>
          2.5. Після завершення гри кожен учасник повертається до кімнати та обирає з двох варіантів результат гри; протягом 1 хвилини можна виправити вказаний користувачем результат у разі помилки. У разі відсутності спору призовий фонд кімнати розподіляється між переможцями відповідно до умов Кімнати (за принципом «переможець забирає все») та автоматично зараховується на рахунки переможців у Платформі, за вирахуванням комісії Платформи за арбітраж (10% від бюджету Платформи).
          </p>
          <p>
          Завідомо неправдиве повідомлення про результати гри вважатиметься фродом (проявом нечесної гри) і тягнутиме за собою дисциплінарні заходи стосовно недобросовісного учасника кімнати.
          </p>
          <p>
          Розбіжності у визначенні результатів після їх вказівки учасниками кімнати автоматично відкривають спір за ініціативою та участю всіх учасників кімнати.
          </p>
          <p>
          3. ОБОВ'ЯЗКИ УЧАСНИКІВ
          </p>
          <p>
          3.1. Кожен Учасник зобов'язується:
          </p>
          <p>
          •	дотримуватися встановлених правил чесної гри;
          </p>
          <p>
          •	не використовувати сторонні програми, скрипти або будь-які засоби шахрайства;
          </p>
          <p>
          •	не порушувати правила етичної поведінки;
          </p>
          <p>
          •	не створювати перешкод для інших Учасників під час проведення гри;
          </p>
          <p>
          •	не намагатися впливати на результати гри шляхом змови чи будь-яких маніпуляцій.
          </p>
          <p>
          4. ПРАВА ОПЕРАТОРА
          </p>
          <p>
          4.1. Оператор має право:
          </p>
          <p>
          •	здійснювати контроль за дотриманням Угоди та інших правил;
          </p>
          <p>
          •	проводити перевірки у разі підозри на порушення правил чесної гри;
          </p>
          <p>
          •	анулювати результати Учасника у разі встановлення фактів порушення;
          </p>
          <p>
          •	накладати санкції згідно з Дисциплінарними правилами, включаючи тимчасове або постійне блокування облікового запису порушника.
          </p>
          <p>
          5. ВІДПОВІДАЛЬНІСТЬ ТА ВИРІШЕННЯ СПОРІВ
          </p>
          <p>
          5.1. Оператор не несе відповідальності за технічні збої, що не залежать від його діяльності, включаючи збої мережі Інтернет, апаратного чи програмного забезпечення Учасників.
          </p>
          <p>
          5.2. У разі виникнення спорів щодо результатів гри, Учасник має право подати скаргу через внутрішню систему Платформи протягом 24 годин після завершення Кімнати, що означає відкриття спору стосовно результатів відповідної Кімнати.
          </p>
          <p>
          5.3. Спори між Учасниками розглядаються Платформою (Арбітражною комісією), яка ухвалює остаточне рішення на основі внутрішньої перевірки та наданих доказів.
          </p>
          <p>
          5.4. Оператор залишає за собою право здійснити перерозподіл призового фонду у разі виявлення порушень або анулювання результатів гри окремих Учасників.
          </p>
          <p>
          6. ЗМІНИ УМОВ УГОДИ
          </p>
          <p>
          6.1. Оператор має право в будь-який момент змінювати умови цієї Угоди. Усі зміни набирають чинності після їх публікації на Платформі.
          </p>
          <p>
          6.2. Продовження участі в Кімнатах після внесення змін до Угоди означає автоматичне прийняття змін Учасником.
          </p>
          <p>
          7. ЗАКЛЮЧНІ ПОЛОЖЕННЯ
          </p>
          <p>
          7.1. Усі правовідносини, що виникають у зв'язку з цією Угодою, регулюються законодавством України.
          </p>
          <p>
          7.2. Якщо будь-яке положення цієї Угоди буде визнане недійсним або незаконним, інші її положення залишаються чинними.
          </p>
          <p>
          7.3. Усі повідомлення, звернення та претензії щодо цієї Угоди надсилаються через офіційні канали зв'язку, зазначені на Платформі.
          </p>
          <p>
          Дата останнього оновлення: 26.03.2025
          </p>

				</p>
      </div>

      <div className="userEditButtons" style={{ marginTop: '70px' }}>
        <button className="prButton prButtonSecond" onClick={onDecline}>Скасувати</button>
        <button
          className="prButton prButtonMain"
          onClick={onConsentClick}
          disabled={isDisabled}
        >
          Погодитись
        </button>
      </div>

    </div>
  )
}

export default RoomConditionsPage;